export default __webpack_public_path__ + "static/media/worm.6f2183b3.svg";